// Sign out must survive the hard redirect that follows it. AuthRedirect
// (used on every non-localhost origin) auto-launches the Salesforce OAuth
// flow whenever the session check 401s — and if the user's Salesforce
// session is still alive, that flow silently signs them straight back in,
// making Sign out look like a page refresh (production bug 2026-07-16).
//
// The flag is set by the logout handler and consumed (read-and-cleared)
// by AuthRedirect, which then shows an explicit sign-in screen instead of
// auto-redirecting. sessionStorage keeps it per-tab and it dies with the
// browser session, so it can never permanently wedge login.

import { forgetReturnTo } from "./returnTo";
import { markSessionEnded } from "./idleSession";

export const SIGNED_OUT_FLAG = "dms_signed_out";

export function markSignedOut() {
  // Signing out on purpose must not bounce the person back into the page
  // they just left once they sign in again.
  forgetReturnTo();
  // Every other WHG Docs tab goes to the sign-in page too.
  markSessionEnded("signed_out");
  try {
    sessionStorage.setItem(SIGNED_OUT_FLAG, "1");
  } catch (error) {
    console.warn("Could not persist signed-out flag:", error);
  }
}

export function consumeSignedOutFlag() {
  try {
    const wasSignedOut = sessionStorage.getItem(SIGNED_OUT_FLAG) === "1";
    if (wasSignedOut) {
      sessionStorage.removeItem(SIGNED_OUT_FLAG);
    }
    return wasSignedOut;
  } catch (error) {
    return false;
  }
}
